import toast from 'react-hot-toast';
import { DEFAULT_APP_TOAST_DURATION_MS, type AppToastPayload } from './appToast.types';
import { ToastNotification } from './ToastNotification';

export function showAppToast(payload: AppToastPayload): void {
  toast.custom(
    t => (
      <ToastNotification
        variant={payload.variant}
        message={payload.message}
        visible={t.visible}
        onRequestClose={() => toast.dismiss(t.id)}
      />
    ),
    { duration: payload.durationMs ?? DEFAULT_APP_TOAST_DURATION_MS }
  );
}

export function hideAppToast(): void {
  toast.dismiss();
}
